import React, { useEffect, useState, useContext } from "react";
import { connect } from "react-redux";
import "./index.css";
import ContextForm from "../../ReportForm/contextForm";

const digitWithZero = value => {
  let digit = Number(value) < 10 ? `0${value}` : value
  return digit
}

const CustomSelectDatePicker = (props) => {
  const { label, isRequired, labelClass, onChange, futureYearsLimit = 0 } = props;
  const context = useContext(ContextForm);
  const { errorFieldsPublicForm, errorFieldsProfessionalForm } = context;

  const [optionsDay, setOptionsDay] = useState([]);
  const [optionsMonth, setOptionsMonth] = useState([]);
  const [optionsYear, setOptionsYear] = useState([]);

  const [currentYear, setCurrentYear] = useState("");
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentDay, setCurrentDay] = useState("");
  const [errorFieldYear, setErrorFieldYear] = useState(false);
  const [errorFieldMonth, setErrorFieldMonth] = useState(false);
  const [errorFieldDay, setErrorFieldDay] = useState(false);

  const handleChangeYear = (event) => {
    if (errorFieldYear) {
      setErrorFieldYear(false);
    }
    setCurrentYear(event.target.value);
    if (currentMonth !== "" && currentDay !== "") {
      onChange(`${event.target.value}-${digitWithZero(currentMonth)}-${digitWithZero(currentDay)}`);
    }
  };
  const handleChangeMonth = (event) => {
    if (errorFieldMonth) {
      setErrorFieldMonth(false);
    }
    setCurrentMonth(event.target.value);
    if (currentYear !== "" && currentDay !== "") {
      onChange(`${currentYear}-${digitWithZero(event.target.value)}-${digitWithZero(currentDay)}`);
    }
  };
  const handleChangeDay = (event) => {
    if (errorFieldDay) {
      setErrorFieldDay(false);
    }
    setCurrentDay(event.target.value);
    if (currentYear !== "" && currentMonth !== "") {
      onChange(`${currentYear}-${digitWithZero(currentMonth)}-${digitWithZero(event.target.value)}`);
    }
  };

  var getDaysInMonth = function (month, year) {
    const max = new Date(year, month, 0).getDate();
    const min = 1;
    const days = [];
    for (let i = max; i >= min; i--) {
      days.push(i);
    }
    setOptionsDay(days);
  };

  const rangeYear = () => {
    let yearLimitTop = Number.isNaN(futureYearsLimit) ? 0 : Number(futureYearsLimit)
    const max = new Date().getFullYear() + yearLimitTop;
    const min = max - 100;
    const years = [];
    for (let i = max; i >= min; i--) {
      years.push(i);
    }
    return years;
  };
  const rangeMonth = () => {
    const max = 12;
    const min = 1;
    const months = [];
    for (let i = max; i >= min; i--) {
      months.push(i);
    }
    return months;
  };

  const setInitialData = () => {
    var today = new Date();
    var m = String(today.getMonth() + 1).padStart(2);
    var yyyy = today.getFullYear();
    getDaysInMonth(m, yyyy);
    const arrayYears = rangeYear();
    const arrayMonths = rangeMonth();
    setOptionsMonth(arrayMonths);
    setOptionsYear(arrayYears);
  };

  useEffect(() => {
    if (
      isRequired &&
      (errorFieldsPublicForm === true || errorFieldsProfessionalForm === true)
    ) {
      if (currentYear === "") {
        setErrorFieldYear(true);
      }
      if (currentMonth === "") {
        setErrorFieldMonth(true);
      }
      if (currentDay === "") {
        setErrorFieldDay(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFieldsPublicForm, errorFieldsProfessionalForm]);

  useEffect(() => {
    getDaysInMonth(currentMonth, currentYear);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentYear, currentMonth]);

  useEffect(() => {
    setInitialData();
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="element">
      <label className={`${labelClass ? labelClass : "label"}`}>
        {label}
        {/* {isRequired && <span>*</span>} */}
      </label>
      <div className="custom-date-picker-container">
        {optionsDay && (
          <select
            // className="custom-select-date-picker height-element"
            className={`custom-select-date-picker height-element ${errorFieldDay ? "error_form" : ""
              }`}
            value={currentDay}
            onChange={handleChangeDay}
          >
            <option value={""} className="label">
              Día
            </option>
            {optionsDay.map((item) => {
              return (
                <option value={item} className="label">
                  {item}
                </option>
              );
            })}
          </select>
        )}
        {optionsMonth && (
          <select
            // className="custom-select-date-picker height-element"
            className={`custom-select-date-picker height-element ${errorFieldMonth ? "error_form" : ""
              }`}
            value={currentMonth}
            onChange={handleChangeMonth}
          >
            <option value={""} className="label">
              Mes
            </option>
            {optionsMonth.map((item) => {
              return (
                <option value={item} className="label">
                  {item}
                </option>
              );
            })}
          </select>
        )}
        {optionsYear && (
          <select
            // className="custom-select-date-picker height-element"
            className={`custom-select-date-picker height-element ${errorFieldYear ? "error_form" : ""
              }`}
            value={currentYear}
            onChange={handleChangeYear}
          >
            <option value={""} className="label">
              Año
            </option>
            {optionsYear.map((item) => {
              return (
                <option value={item} className="label">
                  {item}
                </option>
              );
            })}
          </select>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(CustomSelectDatePicker);
